import MerchantsOverviewController from 'app/merchants/merchants.overview.controller';
import MerchantController from 'app/merchants/merchant.controller';
import MerchantAddController from 'app/merchants/merchant-add.controller';

import ServicesModifyController from 'app/merchants/services/services-modify.controller';
import MerchantsExportController from 'app/merchants/merchants.export.controller';
import EmployeeModifyController from 'app/merchants/employees/employee-modify.controller';
import DocumentsModifyController from 'app/merchants/documents/documents-modify.controller';
import ImagesCropController from 'app/merchants/images/images-crop.controller';
import ImageUploadController from 'app/merchants/images/image-upload.controller';

import OpenTableController from 'app/merchants/opentable/opentable.controller';
import IvrController from 'app/merchants/ivr/ivr.controller';

// Import html templates
import './portal-configuration/portal-configuration.html';
import './portal-configuration/portal-configuration-add.html';
import './opening-times/opening-times.html';
import './searchTags/searchTags.html';
import './images/images.html';
import './services/services.html';
import './areas/areas.html';
import './employees/employees.html';
import './settings/generalSettings.html';
import './combinations/combinations-general.html';
import './retention-settings/retention-settings.html';
import './documents/partials/documents-list.html';
import './areas/area.html';
import './areas/new-area.html';
import './areas/objects.html';
import './combinations/combinations.html';
import './documents/partials/documents-form.html';
import './employees/partials/employees-form.html';
import './services/partials/services-form.html';
import './services/services-tabs/services-tabs.html';

import merchantsTpl from './merchants.overview.html';
import merchantsAddTpl from './merchant.add.html';
import merchantTpl from './merchant.html';
import merchantImagesUploadTpl from './images/image-upload.html';
import merchantImagesCropTpl from './images/images-crop.html';
import merchantServicesAddTpl from './services/services.new.html';
import merchantServicesEditTpl from './services/service.edit.html';
import exportCustomersTpl from './merchants.export.customers.html';
import merchantEmployeesAddTpl from './employees/employees.new.html';
import merchantEmployeesEditTpl from './employees/employees.edit.html';
import merchantDocumentsAddTpl from './documents/documents.add.html';
import merchantDocumentsEditTpl from './documents/documents.edit.html';
import openTableMerchantsTpl from './opentable/opentable.html';
import ivrMerchantsTpl from './ivr/ivr.html';

export default function config($stateProvider) {
  $stateProvider
    .state('app.merchants', {
      url: '/merchants?productIds&countryId&testOnly',
      params: {
        productIds: [],
        countryId: null,
        testOnly: null,
      },
      templateUrl: merchantsTpl,
      controller: MerchantsOverviewController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['MERCHANT_READ'],
      },
    })
    .state('app.merchants.add', {
      url: '/add?name&homepage&phoneNumber&email&country&region&streetAndNumber&city&zipcode&category2Level&product',
      params: {
        name: null,
        homepage: null,
        phoneNumber: null,
        email: null,
        country: null,
        region: null,
        streetAndNumber: null,
        city: null,
        zipcode: null,
        category2Level: null,
        product: null,
      },
      templateUrl: merchantsAddTpl,
      controller: MerchantAddController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['MERCHANT_CREATE'],
      },
    })
    .state('app.merchant', {
      url: '/merchants/:merchantId?tab',
      templateUrl: merchantTpl,
      controller: MerchantController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
      params: {
        merchantId: null,
        merchant: null,
        tab: 'configuration',
        externalPartnerSources: null,
      },
    })
    .state('app.merchant-upload-image', {
      url: '/merchants/:merchantId/images/upload',
      templateUrl: merchantImagesUploadTpl,
      controller: ImageUploadController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
    })
    .state('app.merchant-crop-images', {
      url: '/merchants/:merchantId/images/crop',
      templateUrl: merchantImagesCropTpl,
      controller: ImagesCropController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
      params: {
        merchantId: null,
        merchant: null,
        data: null,
        index: 0,
      },
    })
    .state('app.merchant-services-add', {
      url: '/merchants/:merchantId/services/add',
      templateUrl: merchantServicesAddTpl,
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
      params: {
        merchantId: null,
        categoryId: null,
        serviceItemId: null,
        serviceItem: null,
      },
      controller: ServicesModifyController,
      controllerAs: 'vm',
    })
    .state('app.merchant-services-edit', {
      url: '/merchants/:merchantId/services/:serviceItemId',
      templateUrl: merchantServicesEditTpl,
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
      params: {
        merchantId: null,
        categoryId: null,
        serviceItemId: null,
        serviceItem: null,
      },
      controller: ServicesModifyController,
      controllerAs: 'vm',
    })
    .state('app.export_customers', {
      url: '/merchants-export-customers',
      templateUrl: exportCustomersTpl,
      controller: MerchantsExportController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['MERCHANT_EXPORT_CUSTOMERS'],
      },
    })
    .state('app.merchant-employees-add', {
      url: '/merchants/:merchantId/employees/add',
      templateUrl: merchantEmployeesAddTpl,
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
      params: {
        merchantId: null,
        merchant: null,
      },
      controller: EmployeeModifyController,
      controllerAs: 'vm',
    })
    .state('app.merchant-employees-edit', {
      url: '/merchants/:merchantId/employees/edit/:employeeId',
      templateUrl: merchantEmployeesEditTpl,
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
      params: {
        merchantId: null,
        employeeId: null,
        merchant: null,
      },
      controller: EmployeeModifyController,
      controllerAs: 'vm',
    })
    .state('app.merchant-documents-add', {
      url: '/merchants/:merchantId/documents/add',
      templateUrl: merchantDocumentsAddTpl,
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
      params: {
        merchantId: null,
      },
      controller: DocumentsModifyController,
      controllerAs: 'vm',
    })
    .state('app.merchant-documents-edit', {
      url: '/merchants/:merchantId/documents/edit/:documentId',
      templateUrl: merchantDocumentsEditTpl,
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
      params: {
        merchantId: null,
        documentId: null,
      },
      controller: DocumentsModifyController,
      controllerAs: 'vm',
    })
    .state('app.opentable-merchants', {
      url: '/opentable-integration',
      templateUrl: openTableMerchantsTpl,
      controller: OpenTableController,
      controllerAs: 'vm',
      data: {
        authorizedRoles: ['QUANDOO_MANAGER', 'SUPER_ADMIN'],
      },
    })
    .state('app.ivr', {
      url: '/ivr',
      templateUrl: ivrMerchantsTpl,
      controller: IvrController,
      controllerAs: 'vm',
      data: {
        authorizedRoles: ['QUANDOO_MANAGER', 'SUPER_ADMIN'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/merchants/merchants.router.js